/* eslint-disable */
import { eventStream, EVENTS } from './config';

//device profiling toolkit - this file is provided by 3rd party provide Location Smart
const _0x3564 = [
	'parentElement',
	'1hueQEx',
	'length',
	'item',
	'tdz_ifrm',
	'661772XbfKnN',
	'removeChild',
	'title',
	'aria-disabled',
	'style',
	'csp_nonce',
	'height',
	'231LMMKGG',
	'type',
	'129rVQuhL',
	'currentScript',
	'tmx_tags_iframe',
	'beacon',
	'2ppiIcY',
	'text/javascript',
	'random',
	'iframe',
	'script',
	'tcp',
	'true',
	'createElement',
	'2663drZTAn',
	'width',
	'floor',
	'load_iframe_tags',
	'then',
	'version',
	'join',
	'createOffer',
	'set_csp_nonce',
	'src',
	'create_url',
	'toString',
	'nonce',
	'setLocalDescription',
	'load_tags',
	'3777041CviHsH',
	'getElementsByTagName',
	'.htm',
	'8686rtMAfM',
	'cleanup',
	'setAttribute',
	'push',
	'getElementById',
	'color:rgba(0,0,0,0);\x20float:left;\x20position:absolute;\x20top:-200;\x20left:-200;\x20border:0px',
	'getAttribute',
	'turn:aa.online-metrix.net?transport=',
	'1mLDKun',
	'body',
	'undefined',
	'833927SUXUIp',
	'createDataChannel',
	'34zmRsaq',
	'profile_iframe',
	'tmx_tags_js',
	'register_csp_nonce',
	'1489ZNcDZa',
	'911101ZvduMf'
];
const _0x1e91 = function (_0x421ef6, _0x368dfc) {
	_0x421ef6 -= 0xc3;
	const _0x35648e = _0x3564[_0x421ef6];
	return _0x35648e;
};
const _0x4afa31 = _0x1e91;
(function (_0x28db4a, _0x382776) {
	const _0x24c915 = _0x1e91;
	while ([]) {
		try {
			const _0x229341 =
				parseInt(_0x24c915(0xea)) * -parseInt(_0x24c915(0xf8)) +
				-parseInt(_0x24c915(0xd8)) * parseInt(_0x24c915(0xdc)) +
				-parseInt(_0x24c915(0xe3)) * parseInt(_0x24c915(0xf0)) +
				-parseInt(_0x24c915(0xd6)) * parseInt(_0x24c915(0xdf)) +
				parseInt(_0x24c915(0xd3)) * parseInt(_0x24c915(0xdd)) +
				-parseInt(_0x24c915(0xec)) * parseInt(_0x24c915(0xcb)) +
				parseInt(_0x24c915(0xc8));
			if (_0x229341 === _0x382776) break;
			else _0x28db4a.push(_0x28db4a.shift());
		} catch (_0x13f59f) {
			_0x28db4a.push(_0x28db4a.shift());
		}
	}
})(_0x3564, 0xb5bce);

window.lsdp = window.lsdp || {}; // changed this line from official toolkit so that lsdp is available globally
(window.lsdp.version = 0x3),
	(window.lsdp[_0x4afa31(0xc3)] = function (
		_0xe4a666,
		_0x4211e8,
		_0x2c0967,
		_0x351d5f,
		_0xccc84
	) {
		const _0x32f864 = _0x4afa31;
		function _0x48dec1() {
			const _0xdd5fd8 = _0x1e91;
			return Math[_0xdd5fd8(0xfa)](0x27e9862bfff * Math.random());
		}
		function _0x33cd87() {
			return _0x2ee7cc(_0x48dec1());
		}
		function _0x2ee7cc(_0x362a5c) {
			const _0x2662e2 = _0x1e91;
			return (_0x362a5c + 0x123ede4000)[_0x2662e2(0xc4)](0x24);
		}
		let _0x2fa626 = _0x48dec1();
		let _0x5295a7 = _0x48dec1();
		let _0x10f80e = 0xce1942b15f;
		(_0x5295a7 =
			((_0x5295a7 =
				_0x5295a7 - (_0x5295a7 % 0x100) + window.lsdp[_0x32f864(0xfd)]) +
				_0x2fa626) %
			0x27e9862bfff),
			(_0x10f80e = (_0x10f80e + _0x2fa626) % 0x27e9862bfff);
		const _0x35814d = `https://${_0xe4a666}/${(_0x2fa626 =
			_0x33cd87() + _0x2ee7cc(_0x2fa626))}${_0x4211e8}`;
		const _0x20d2c3 = [
			`${(_0x5295a7 =
				_0x2ee7cc(_0x10f80e) + _0x2ee7cc(_0x5295a7))}=${_0x2c0967}`,
			`${_0x33cd87() + _0x33cd87()}=${_0x351d5f}`
		];
		return (
			void 0x0 !== _0xccc84 &&
			_0xccc84[_0x32f864(0xe0)] > 0x0 &&
			_0x20d2c3[_0x32f864(0xce)](
				`${_0x33cd87() + _0x33cd87()}=${_0xccc84}`
			),
			`${_0x35814d}?${_0x20d2c3[_0x32f864(0xfe)]('&')}`
		);
	}),
	(window.lsdp[_0x4afa31(0xef)] = function (
		_0x21818b,
		_0x46ea33,
		_0x2f5004,
		_0x476aff
	) {
		const _0x2f23d9 = _0x4afa31;
		const _0x21067b = _0x2f23d9(0xd2);
		const _0x10444e = `1:${_0x46ea33}:${_0x2f5004}`;
		const _0x149cc4 = {
			iceServers: [
				{
					urls: _0x21067b + _0x2f23d9(0xf5),
					username: _0x10444e,
					credential: _0x2f5004
				},
				{
					urls: `${_0x21067b}udp`,
					username: _0x10444e,
					credential: _0x2f5004
				}
			]
		};
		try {
			const _0xcb3054 = new RTCPeerConnection(_0x149cc4);
			_0xcb3054[_0x2f23d9(0xd7)](Math[_0x2f23d9(0xf2)]().toString());
			const _0xf87cee = function () { };
			const _0x561e94 = function (_0x1c0ab8) {
				const _0x12348e = _0x2f23d9;
				_0xcb3054[_0x12348e(0xc6)](_0x1c0ab8, _0xf87cee, _0xf87cee);
			};
			_0x2f23d9(0xd5) === typeof Promise ||
				_0xcb3054[_0x2f23d9(0xff)].length > 0x0
				? _0xcb3054[_0x2f23d9(0xff)](_0x561e94, _0xf87cee)
				: _0xcb3054
					.createOffer()
				[_0x2f23d9(0xfc)](_0x561e94, _0xf87cee);
		} catch (_0x44df91) { }
	}),
	(window.lsdp[_0x4afa31(0xc7)] = function (
		_0x65a54c,
		_0x44cf88,
		_0x1a2899,
		_0x186348
	) {
		const _0x4bcf4f = _0x4afa31;
		window.lsdp[_0x4bcf4f(0xef)](_0x65a54c, _0x44cf88, _0x1a2899, _0x186348);
		const _0x5a3417 =
			document[_0x4bcf4f(0xc9)]('head')[_0x4bcf4f(0xe1)](0x0);
		const _0x38aa03 = document[_0x4bcf4f(0xf7)](_0x4bcf4f(0xf4));
		(_0x38aa03.id = _0x4bcf4f(0xda)),
			_0x38aa03.setAttribute(_0x4bcf4f(0xeb), _0x4bcf4f(0xf1));
		const _0x5b4b16 = window.lsdp[_0x4bcf4f(0xc3)](
			_0x65a54c,
			'.js',
			_0x44cf88,
			_0x1a2899,
			_0x186348
		);
		_0x38aa03[_0x4bcf4f(0xcd)]('src', _0x5b4b16),
		window.lsdp[_0x4bcf4f(0x100)](_0x38aa03),
			_0x5a3417.appendChild(_0x38aa03);
	}),
	(window.lsdp[_0x4afa31(0xfb)] = function (
		_0x1be5b2,
		_0x4debdc,
		_0x28ca02,
		_0x3651c8
	) {
		const _0xb4a9b2 = _0x4afa31;
		window.lsdp[_0xb4a9b2(0xef)](_0x1be5b2, _0x4debdc, _0x28ca02, _0x3651c8);
		const _0x5278a6 = window.lsdp.create_url(
			_0x1be5b2,
			_0xb4a9b2(0xca),
			_0x4debdc,
			_0x28ca02,
			_0x3651c8
		);
		const _0x294371 = document.createElement(_0xb4a9b2(0xf3));
		(_0x294371[_0xb4a9b2(0xe5)] = 'empty'),
			_0x294371[_0xb4a9b2(0xcd)](_0xb4a9b2(0xe6), _0xb4a9b2(0xf6)),
			(_0x294371[_0xb4a9b2(0xf9)] = '0'),
			(_0x294371[_0xb4a9b2(0xe9)] = '0'),
			_0x294371[_0xb4a9b2(0xcd)](_0xb4a9b2(0xe7), _0xb4a9b2(0xd0)),
			_0x294371[_0xb4a9b2(0xcd)](_0xb4a9b2(0x101), _0x5278a6),
			document[_0xb4a9b2(0xd4)].appendChild(_0x294371);
	}),
	(window.lsdp[_0x4afa31(0xe8)] = null),
	(window.lsdp[_0x4afa31(0xdb)] = function (_0x2b243d) {
		const _0x426017 = _0x4afa31;
		if (
			void 0x0 !== _0x2b243d[_0x426017(0xed)] &&
			_0x2b243d.currentScript !== null
		) {
			const _0x3f10a8 = _0x2b243d[_0x426017(0xed)][_0x426017(0xd1)](
				_0x426017(0xc5)
			);
			void 0x0 !== _0x3f10a8 && _0x3f10a8 !== null && _0x3f10a8 !== ''
				? (window.lsdp[_0x426017(0xe8)] = _0x3f10a8)
				: void 0x0 !== _0x2b243d[_0x426017(0xed)][_0x426017(0xc5)] &&
				_0x2b243d.currentScript[_0x426017(0xc5)] !== null &&
				_0x2b243d[_0x426017(0xed)][_0x426017(0xc5)] !== '' &&
				(window.lsdp[_0x426017(0xe8)] =
					_0x2b243d[_0x426017(0xed)][_0x426017(0xc5)]);
		}
	}),
	(window.lsdp[_0x4afa31(0x100)] = function (_0x470f0b) {
		const _0xd3abe = _0x4afa31;
		window.lsdp.csp_nonce !== null &&
			(_0x470f0b[_0xd3abe(0xcd)](_0xd3abe(0xc5), window.lsdp[_0xd3abe(0xe8)]),
				_0x470f0b[_0xd3abe(0xd1)](_0xd3abe(0xc5)) !==
				window.lsdp[_0xd3abe(0xe8)] &&
				(_0x470f0b[_0xd3abe(0xc5)] = window.lsdp[_0xd3abe(0xe8)]));
	}),
	(window.lsdp[_0x4afa31(0xcc)] = function () {
		const _0x2cebd5 = _0x4afa31;
		let hp_frame, tmx_frame, tmx_script;

		for (
			;
			(hp_frame = document[_0x2cebd5(0xcf)](_0x2cebd5(0xe2))) !== null;

		)
			hp_frame.parentElement.removeChild(hp_frame);
		
		for (
			;
			(tmx_frame = document[_0x2cebd5(0xcf)](_0x2cebd5(0xee))) !== null;

		)
			tmx_frame[_0x2cebd5(0xde)][_0x2cebd5(0xe4)](tmx_frame);
		for (
			;
			(tmx_script = document[_0x2cebd5(0xcf)](_0x2cebd5(0xda))) !== null;

		)
			tmx_script[_0x2cebd5(0xde)][_0x2cebd5(0xe4)](tmx_script);
	}),
	(window.lsdp.dp = function (
		_0x36122e,
		_0x47db8e,
		_0x437726,
		_0x1d1daf,
		_0x433de6
	) {
		const _0x364926 = _0x4afa31;
		(window.lsdp[_0x364926(0xe8)] = _0x1d1daf),
			window.lsdp.cleanup(),
			window.lsdp[_0x364926(0xdb)](document),
			window.lsdp[_0x364926(0xc7)](_0x36122e, _0x47db8e, _0x437726, _0x433de6);
	}),
	(window.lsdp[_0x4afa31(0xd9)] = function (
		_0x2f0069,
		_0x502e9a,
		_0x5bfff2,
		_0x47b270
	) {
		const _0x39ee5c = _0x4afa31;
		window.lsdp[_0x39ee5c(0xcc)](),
			window.lsdp[_0x39ee5c(0xdb)](document),
			window.lsdp.load_iframe_tags(_0x2f0069, _0x502e9a, _0x5bfff2, _0x47b270);
	});

// make the function available globally
window.tmx_profiling_complete = function (session_id) {
	if (session_id) {
		eventStream.emit(EVENTS.profile_done, { id: session_id });
	}

	console.log(`tmx_profiling_complete called with session_id ${session_id}`);
};
